import '../css/Navigation.css';
import {Link} from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import {useState, useEffect, useRef} from 'react';
import logo from '../assets/logo.png';

const Navigation = () => {

    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [gamesOpen, setGamesOpen] = useState(false);
    const gamesRef = useRef(null);
    const accountRef = useRef(null);

    const handleLogout = async () => {
        try {
             fetch(`${process.env.REACT_APP_API_URL}/api/users/logout`, { 
            //await fetch('http://localhost:5001/api/users/logout', { 
                method: 'POST',
                credentials: 'include',
            });
            navigate('/');
        } catch (error) {
            console.error('Error during logout:', error);
        }
    };

    useEffect(() => {
        function handleClickOutside(event){
            if(gamesRef.current && !gamesRef.current.contains(event.target)){
                setGamesOpen(false);
            }
            if(accountRef.current && !accountRef.current.contains(event.target)){
                setDropdownOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    })

    return (
        <nav id="main-nav">
            <ul id="nav-list">

                <li><Link to="/home" className="my-link" title="Go to Home">
                    <img src={logo} alt="Home" style={{ height: '40px', width: 'auto' }} />
                </Link></li>
                <li><Link to="/sports/football" className="my-link">Football</Link></li>
                <li><Link to="sports/soccer/premier-league" className="my-link">Soccer</Link></li>
                <li className="account-menu" ref={gamesRef}>
                    <button className="my-link account-btn" onClick={() => setGamesOpen(!gamesOpen)}>
                        <span>Games</span>
                    </button>
                    {gamesOpen && (
                        <div className='account-dropdown'>
                            <Link to="/football-games" className="dropdown-item">
                                <button className="dropdown-item" onClick={() => setGamesOpen(false)}>
                                    Football
                                </button>
                            </Link>
                            <Link to="/soccer-games" className="dropdown-item">
                                <button className="dropdown-item" onClick={() => setGamesOpen(false)}>
                                    Soccer
                                </button>
                            </Link>
                        </div>
                    )}
                </li>
                <li className="account-menu" ref={accountRef}>
                    <button className="my-link account-btn" onClick={() => setDropdownOpen(!dropdownOpen)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
                        </svg>
                        <span>Account</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M7 10l5 5 5-5z"/>
                        </svg>
                    </button>
                    {dropdownOpen && (
                        <div className='account-dropdown'>
                            <Link to="/settings"
                            className="dropdown-item"
                            onClick={()=> setDropdownOpen(false)}
                            >
                                Settings
                            </Link>
                            <button className="dropdown-item" onClick={handleLogout}>
                                Logout
                            </button>
                        </div>
                    )}
                </li>
            </ul>
        </nav>
    );
};

export default Navigation; 